// Helper function to calculate the radius from a bounding box
export const calculateRadiusFromBoundingBox = (boundingBox: {
  ne: { latitude: number; longitude: number }
  sw: { latitude: number; longitude: number }
}): number => {
  const { ne, sw } = boundingBox

  // Calculate the center of the bounding box
  const centerLat = (ne.latitude + sw.latitude) / 2
  const centerLng = (ne.longitude + sw.longitude) / 2

  // Calculate the distance from the center to the northeast corner
  const toRadians = (degrees: number) => degrees * (Math.PI / 180)
  const R = 6371 // Earth's radius in km

  const dLat = toRadians(ne.latitude - centerLat)
  const dLng = toRadians(ne.longitude - centerLng)

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(centerLat)) *
      Math.cos(toRadians(ne.latitude)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2)

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))

  // calculate the radius,
  // reduce decimals and round to the nearest integer
  return Math.round(Number((R * c).toFixed(2)))
}
